import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import memberWelcome from './zh-CN/memberWelcome';
import register from './zh-CN/register';
import staff from './zh-CN/staff';
import memberList from './zh-CN/memberList';
import dashboard from './zh-CN/dashboard';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.copyright.produced': '蓝海科技工作室出品',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...memberWelcome,
  ...register,
  ...staff,
  ...memberList,
  ...dashboard,
  'pages.403.subTitle': '抱歉，您没有访问此页面的权限。',
  'pages.403.back': '返回首页',
  'menu.account.logout': '退出登录',
  'menu.account.logout.confirm': '确认退出登录',
  'menu.account.logout.confirm.content': '您确定要退出登录吗？',
  'menu.account.logout.success': '已成功退出登录',
  'menu.account.logout.failed': '退出登录失败',
  
  'menu.account.changePassword': '修改密码',
  'menu.account.changePassword.currentPassword': '当前密码',
  'menu.account.changePassword.currentPassword.required': '请输入当前密码',
  'menu.account.changePassword.newPassword': '新密码',
  'menu.account.changePassword.newPassword.required': '请输入新密码',
  'menu.account.changePassword.password.tooShort': '密码长度不能少于6个字符',
  'menu.account.changePassword.confirmPassword': '确认新密码',
  'menu.account.changePassword.confirmPassword.required': '请确认新密码',
  'menu.account.changePassword.passwordMismatch': '两次输入的密码不一致',
  'menu.account.changePassword.success': '密码修改成功',
  'menu.account.changePassword.failed': '密码修改失败',
  'menu.account.changePassword.incorrectPassword': '当前密码不正确',
  'pages.memberList.pagination.total': '共 {total} 条记录',
  'pages.memberList.pagination.pageSize': '条/页',
  'pages.memberList.pagination.jump': '跳至',
  'pages.memberList.pagination.page': '页',
  
  // 礼品卡列表
  'pages.giftCardList.title': '礼品卡列表',
  'pages.giftCardList.create': '创建礼品卡',
  'pages.giftCardList.createVirtual': '创建虚拟礼品卡',
  'pages.giftCardList.createPhysical': '创建实体礼品卡',
  'pages.giftCardList.downloadPhysical': '批量下载实体卡号',
  'pages.giftCardList.code': '礼品卡编号',
  'pages.giftCardList.physicalCardNumber': '实体卡号',
  'pages.giftCardList.value': '礼品卡面值',
  'pages.giftCardList.initialAmount': '初始金额',
  'pages.giftCardList.balance': '剩余余额',
  'pages.giftCardList.balanceStatus': '余额',
  'pages.giftCardList.balanceStatus.all': '全部礼品卡',
  'pages.giftCardList.balanceStatus.withBalance': '有余额',
  'pages.giftCardList.balanceStatus.withoutBalance': '无余额',
  'pages.giftCardList.status': '状态',
  'pages.giftCardList.createTime': '创建时间',
  'pages.giftCardList.activeDate': '激活日期',
  'pages.giftCardList.activeBy': '激活人',
  'pages.giftCardList.activationStatus': '激活状态',
  'pages.giftCardList.activationStatus.all': '全部礼品卡',
  'pages.giftCardList.activationStatus.active': '已激活',
  'pages.giftCardList.activationStatus.inactive': '未激活',
  'pages.giftCardList.expiryDate': '到期日期',
  'pages.giftCardList.validDays': '有效期（天）',
  'pages.giftCardList.actions': '操作',
  'pages.giftCardList.actions.details': '详情',
  'pages.giftCardList.note': '备注',
  'pages.giftCardList.date': '日期范围',
  'pages.giftCardList.refresh': '刷新',
  'pages.giftCardList.email': '电子邮箱',
  'pages.giftCardList.phone': '手机号码',
  'pages.giftCardList.tempEmail': '临时电子邮箱',
  'pages.giftCardList.tempPhone': '临时手机号码',
  'pages.giftCardList.contactInfo': '联系方式类型',
  'pages.giftCardList.search.infoType.placeholder': '请选择联系方式类型',
  'pages.giftCardList.contactValue': '联系方式',
  'pages.giftCardList.search.infoValue.placeholder': '请输入联系方式',
  'pages.giftCardList.createDate': '创建日期',
  
  'pages.giftCardList.search.code.placeholder': '请输入礼品卡编号',
  'pages.giftCardList.search.cardNumber': 'Card ID / 实体卡号',
  'pages.giftCardList.search.status.placeholder': '请选择状态',
  'pages.giftCardList.search.date.start': '开始日期',
  'pages.giftCardList.search.date.end': '结束日期',
  'pages.giftCardList.search.submit': '搜索',
  'pages.giftCardList.search.reset': '重置',
  
  'pages.giftCardList.create.success': '礼品卡创建成功',
  'pages.giftCardList.create.error': '礼品卡创建失败',
  'pages.giftCardList.create.value.required': '请输入礼品卡面值',
  'pages.giftCardList.create.value.placeholder': '请输入礼品卡面值',
  'pages.giftCardList.create.balance.required': '请输入初始余额',
  'pages.giftCardList.create.balance.placeholder': '请输入初始余额',
  'pages.giftCardList.create.initialAmount.required': '请输入初始金额',
  'pages.giftCardList.create.initialAmount.placeholder': '请输入初始金额',
  'pages.giftCardList.create.email.placeholder': '请输入电子邮箱',
  'pages.giftCardList.create.phone.placeholder': '请输入手机号码',
  'pages.giftCardList.create.expiryDate.placeholder': '请选择到期日期',
  'pages.giftCardList.create.validDays.required': '请输入有效天数',
  'pages.giftCardList.create.validDays.placeholder': '请输入有效天数',
  'pages.giftCardList.create.note.placeholder': '请输入备注信息',
  'pages.giftCardList.physical.issuingStore': '发卡门店',
  'pages.giftCardList.physical.storeRequired': '请选择发卡门店',
  'pages.giftCardList.physical.quantity': '数量',
  'pages.giftCardList.physical.batch': '创建批次',
  'pages.giftCardList.physical.allBatches': '全部实体礼品卡',
  'pages.giftCardList.physical.loadError': '加载实体礼品卡选项失败',
  'pages.giftCardList.physical.createSuccess': '已创建 {count} 张实体礼品卡',
  'pages.giftCardList.physical.createError': '创建实体礼品卡失败',
  'pages.giftCardList.physical.batchLoadError': '加载实体礼品卡批次失败',
  'pages.giftCardList.physical.downloadError': '下载实体卡号失败',
  
  'pages.giftCardList.level': '礼品卡类型',
  'pages.giftCardList.create.level.required': '请选择礼品卡类型',
  'pages.giftCardList.create.level.placeholder': '请选择礼品卡类型',
  'pages.giftCardList.error.headOffice': '无法获取总部信息',
  'pages.giftCardList.error.fetchLevels': '获取礼品卡类型失败',
  'pages.giftCardList.error.storeId': '未找到门店ID',
  'pages.giftCardList.error.invalidStoreId': '门店ID格式不正确',
  'pages.giftCardList.error.fetchFailed': '获取礼品卡列表失败',
  'pages.giftCardList.error.fetchStoreFailed': '获取门店信息失败',
  'pages.giftCardList.error.noLevels': '未找到礼品卡等级配置，请先在管理后台创建礼品卡等级',
  
  'pages.giftCardList.status.active': '激活',
  'pages.giftCardList.status.inactive': '未激活',
  'pages.giftCardList.status.expired': '已过期',
  'pages.giftCardList.status.used': '已使用',
  'pages.giftCardList.status.cancelled': '已取消',
  
  'pages.giftCardList.pagination.total': '共 {total} 条记录',
  'pages.giftCardList.pagination.pageSize': '条/页',
  'pages.giftCardList.pagination.jump': '跳至',
  'pages.giftCardList.pagination.page': '页',
  
  'app.common.cancel': '取消',
  'app.common.create': '创建',
  'pages.store.giftCardDetails.send.email': '发送邮件',
  'pages.store.giftCardDetails.send.phone': '发送短信',
  'pages.store.giftCardDetails.send.card': '发送卡片',
  'pages.store.giftCardDetails.send.wallet': '发送到钱包',
  'pages.store.giftCardDetails.email.placeholder': '请输入电子邮箱',
  'pages.store.giftCardDetails.phone.placeholder': '请输入手机号码',
  
};
